import React from "react";
import "../PageStyles.css";

const Visions = () => {
  return (
    <section className="page-section about-section">
      <h1>Our Vision: A Global Footprint for Peaceful Dialogue</h1>

      <p>
        Building on our academic success in Türkiye, our vision is to expand Ottomun’s
        educational environment worldwide — connecting students from every background to
        promote empathy, understanding, and cooperation.
      </p>

      <p>
        By empowering the youth of today with diplomatic skills and a global network, we are
        shaping a more peaceful world for tomorrow.
      </p>

      <p className="about-footer">
        Join us at Ottomun — don’t just simulate change. <strong>Create it.</strong>
      </p>


    </section>
  );
};

export default Visions;
